import { request, requestForm } from '../../Common/api/client';

function normalizeApiError(error) {
  const body = error?.response?.data;
  if (body && typeof body === 'object') {
    const normalized = new Error(body.msg || error.message || '요청 처리에 실패했습니다.');
    normalized.code = Number(body.code);
    normalized.data = body.data;
    normalized.response = error.response;
    return normalized;
  }
  return error;
}

async function gasystemRequest(config, form = false) {
  try {
    return await (form ? requestForm(config) : request(config));
  } catch (error) {
    throw normalizeApiError(error);
  }
}

export function getGasystemCpImportCapability() {
  return gasystemRequest({
    method: 'GET',
    url: '/api/admin/gasystem/cp-import/capability',
  });
}

export function previewGasystemCpImport(file) {
  const data = new FormData();
  data.append('file', file);
  return gasystemRequest({
    method: 'POST',
    url: '/api/admin/gasystem/cp-import/preview',
    data,
  }, true);
}

export function getGasystemCpImportBatches(params = {}) {
  return gasystemRequest({
    method: 'GET',
    url: '/api/admin/gasystem/cp-import/batches',
    params,
  });
}

export function getGasystemCpImportBatch(batchId, params = {}) {
  return gasystemRequest({
    method: 'GET',
    url: `/api/admin/gasystem/cp-import/batches/${encodeURIComponent(batchId)}`,
    params,
  });
}

export function applyGasystemCpImportBatch(batchId) {
  return gasystemRequest({
    method: 'POST',
    url: `/api/admin/gasystem/cp-import/batches/${encodeURIComponent(batchId)}/apply`,
  });
}
